import React from "react";
import { Instagram, Anchor, Cookie } from "lucide-react";
import HypeHafenLogo from "./HypeHafenLogo";
import { useCookieConsent } from "../context/CookieConsentContext";

export default function Footer() {
  const year = new Date().getFullYear();
  const { openSettings } = useCookieConsent();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer data-testid="site-footer" className="bg-[#2E2E2E] text-white pt-20 pb-10 relative overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 border-b border-white/10 pb-12">
          <div className="lg:col-span-5">
            <div className="origin-left scale-[0.6] sm:scale-100">
              <HypeHafenLogo height={96} />
            </div>
            <p className="mt-6 font-body text-white/65 text-sm max-w-md leading-relaxed">
              Hype Hafen macht Marken durch strategischen Content und konsistentes
              Social Media Management sichtbar – mit Fokus auf organisches Wachstum.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href="https://www.instagram.com/hype_hafen"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-instagram"
                aria-label="Instagram – @hype_hafen"
                className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center hover:border-[#FFF44F] hover:text-[#FFF44F] transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="font-display text-[0.72rem] tracking-[0.22em] uppercase text-[#FFF44F] mb-4">Navigation</div>
            <ul className="space-y-2.5 font-body text-white/75 text-sm">
              {[
                { id: "leistungen", label: "Leistungen" },
                { id: "ueber-uns", label: "Über uns" },
                { id: "prozess", label: "Prozess" },
                { id: "kontakt", label: "Kontakt" },
              ].map((l) => (
                <li key={l.id}>
                  <button data-testid={`footer-link-${l.id}`} onClick={() => scrollTo(l.id)} className="hover:text-[#FFF44F]">{l.label}</button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-display text-[0.72rem] tracking-[0.22em] uppercase text-[#FFF44F] mb-4">Kontakt</div>
            <ul className="space-y-2.5 font-body text-white/75 text-sm">
              <li><a href="mailto:kontakt@hype-hafen.de" className="hover:text-[#FFF44F]">kontakt@hype-hafen.de</a></li>
              <li>Aus Hamburg für Hamburg</li>
              <li className="pt-2">
                <button onClick={() => scrollTo("kontakt")} className="hh-btn-primary !py-3 !px-5 text-sm">
                  <Anchor className="w-4 h-4" />
                  Erstgespräch buchen
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-8 font-body text-xs text-white/50">
          <div>© {year} Hype Hafen. Aufmerksamkeit. Strategie. Wachstum.</div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <a href="/impressum" data-testid="footer-link-impressum" className="hover:text-[#FFF44F]">Impressum</a>
            <a href="/datenschutz" data-testid="footer-link-datenschutz" className="hover:text-[#FFF44F]">Datenschutz</a>
            <button
              type="button"
              onClick={openSettings}
              data-testid="footer-link-cookie-settings"
              className="inline-flex items-center gap-1.5 hover:text-[#FFF44F]"
            >
              <Cookie className="w-3.5 h-3.5" aria-hidden="true" />
              Cookie-Einstellungen
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
